// routes/_terms.legal.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_terms.legal')

export const handle = { name: 'legal-for-payment' }

export default dynamic(getClientModule, { ssr: false })
